import { useEffect } from "react";
import "./CustomCursor.css";

export default function CustomCursor() {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return undefined;

    const cursor = document.querySelector(".custom-cursor");
    if (!cursor) return undefined;

    const moveCursor = (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };

    window.addEventListener("mousemove", moveCursor);
    return () => window.removeEventListener("mousemove", moveCursor);
  }, []);

  return <div className="custom-cursor"></div>;
}
